import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
  Stack,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: '#008081',
        color: 'white',
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={8}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>

            <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.7)' }}>
              Leading provider of geospatial solutions across the World, delivering geospatial technologies for sustainable development.
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
              <IconButton 
                size="small" 
                sx={{ color: 'blue' }}
                href="https://www.facebook.com/profile.php?id=61575115388714"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton 
                size="small" 
                sx={{ color: '#1DA1F2' }}
                href="https://x.com/geomapsafrica"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon />
              </IconButton>
              <IconButton 
                size="small" 
                sx={{ color: '#E4405F' }}
                href="https://www.instagram.com/geomaps_africa/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton 
                size="small" 
                sx={{ color: 'white' }}
                href="https://www.linkedin.com/company/geomaps-africa/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>            
            </Stack>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ mb: 3 }}>
              Quick Links
            </Typography>
            {[
              { text: 'Home', path: '/' },
              { text: 'About', path: '/about/vision-mission' },
              { text: 'Products', path: '/products' },
              { text: 'Solutions', path: '/solutions' },
              { text: 'News & Blogs', path: '/news' },
              { text: 'Contact', path: '/contact' },
            ].map((item) => (
              <Link
                key={item.text}
                component={RouterLink}
                to={item.path}
                underline="none"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  display: 'block',
                  mb: 1.5,
                  '&:hover': {
                    color: 'white',
                  },
                }}
              >
                {item.text}
              </Link>
            ))}
          </Grid>

          {/* Solutions */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 3 }}>
              Our Solutions
            </Typography>
            {[
              { text: 'Aerial & LiDAR Mapping', path: '/solutions/aerial-photography' },
              { text: 'Drone Mapping', path: '/solutions/drone-mapping' },
              { text: 'Satellite Imagery', path: '/solutions/satellite-imagery' },
              { text: 'Geodetic Survey', path: '/solutions/geodetic-survey' },
              { text: 'Hydrographic Survey', path: '/solutions/hydrographic-survey' },
              { text: 'GIS Mapping', path: '/solutions/gis-developments' },
            ].map((solution) => (
              <Link
                key={solution.text}
                component={RouterLink}
                to={solution.path}
                underline="none"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  display: 'block',
                  mb: 1.5,
                  '&:hover': {
                    color: 'white',
                  },
                }}
              >
                {solution.text}
              </Link>
            ))}
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ mb: 3 }}>
              Contact Us
            </Typography>
            <Stack spacing={3}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <LocationOnIcon sx={{ color: 'white' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  Geomaps Centre,<br/> 
                  9th Flr Matumbato Rd,<br/>                  
                  Nairobi, Kenya
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <PhoneIcon sx={{ color: 'white' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  +254 724 253 622
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <EmailIcon sx={{ color: 'white' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  info@geoafrica.com
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 8, mb: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            © {new Date().getFullYear()} Geomaps. All rights reserved.
          </Typography>
          <Box>
            <Link
              component={RouterLink}
              to="/about/legal"
              underline="none"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                mx: 2,
                '&:hover': { color: 'white' },
              }}
            >
              Legal
            </Link>
            <Link
              component={RouterLink}
              to="/about/responsibility"
              underline="none"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                mx: 2,
                '&:hover': { color: 'white' },
              }}
            >
              Corporate Responsibility
            </Link>
            <Link
              href="http://192.168.100.184:8000/admin/"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                '&:hover': { color: 'white' },
              }}
            >
              Geosite
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 